import BMap from 'BMap'
let geoc = new BMap.Geocoder()
/**
 *根据坐标获取地图的实际地理位置
 *  逆坐标解析
 * @param {*} point lng,lat 百度坐标实例
 * 返回一个promise
 */
export const getLocalPosition = (point) => {
  return new Promise((resolve, reject) => {
    if (point instanceof BMap.Point) {
      geoc.getLocation(point, (res) => {
        // console.log(res)
        if (res === null) {
          reject('地址解析失败')
        }
        let address
        if (res.address !== '') {
          address = res.address
        } else if ((res.addressComponents.city !== '') && (res.addressComponents
            .country !== '')) {
          address = res.addressComponents.city + ', ' + res.addressComponents
            .country
        }
        // console.log(address)
        resolve(address)
      })
    } else {
      reject('请传入百度坐标系点坐标实例！')
    }
  })
}

export const parsePoint = (point) => {
  return new Promise((resolve, reject) => {
    if (point instanceof BMap.Point) {
      geoc.getLocation(point, (res) => {
        if (res === null) {
          reject('地址解析失败')
        }
        resolve(res)
      })
    } else {
      reject('请传入百度坐标系点坐标实例！')
    }
  })
}

// 计算2个经纬度点之间的距离
let DEF_PI = 3.14159265359; // PI
let DEF_2PI = 6.28318530712; // 2*PI
let DEF_PI180 = 0.01745329252; // PI/180.0
let DEF_R = 6370693.5; // radius of earth
export const getDistance = (lon1, lat1, lon2, lat2) => {
  let ew1, ns1, ew2, ns2;
  let dx, dy, dew;
  let distance;
  // 角度转换为弧度
  ew1 = lon1 * DEF_PI180;
  ns1 = lat1 * DEF_PI180;
  ew2 = lon2 * DEF_PI180;
  ns2 = lat2 * DEF_PI180;
  // 经度差
  dew = ew1 - ew2;
  // 若跨东经和西经180 度，进行调整
  if (dew > DEF_PI)
    dew = DEF_2PI - dew;
  else if (dew < -DEF_PI)
    dew = DEF_2PI + dew;
  dx = DEF_R * Math.cos(ns1) * dew; // 东西方向长度(在纬度圈上的投影长度)
  dy = DEF_R * (ns1 - ns2); // 南北方向长度(在经度圈上的投影长度)
  // 勾股定理求斜边长
  distance = Math.sqrt(dx * dx + dy * dy).toFixed(0);
  // console.log(distance)
  return distance
}
// getDistance(116.357428,39.90923,116.397428,39.90923)

export default {
  getLocalPosition,
  parsePoint,
  getDistance
}